var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 32,
    viewBox: "0 0 47 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45.6667,
    height: 31,
    rx: 5.5,
    stroke: "#E5E5EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3514 24.5117H34.5182C34.712 24.5117 34.868 24.4101 34.868 24.2927V10.2186C34.868 10.1005 34.712 10 34.5182 10H11.3552C11.2498 10 11.1699 10.0229 11.1133 10.0585C11.1133 10.0585 11.1107 10.0619 11.1088 10.0656C11.1088 10.0656 11.1017 10.0664 11.0975 10.0735C11.0405 10.1046 11.0034 10.1549 11.0034 10.2186V24.2935C11.0034 24.4109 11.1632 24.5117 11.3548 24.5117",
    fill: "#E4C6B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8516 23.5244H34.5527C34.7249 23.5244 34.8662 23.4329 34.8662 23.3279V10.7497C34.8662 10.6443 34.7249 10.5547 34.5527 10.5547H13.8516C13.7567 10.5547 13.6855 10.5749 13.6349 10.6068C13.6349 10.6068 13.6322 10.6102 13.6315 10.6132C13.6244 10.6132 13.6244 10.6139 13.621 10.6203C13.5707 10.6477 13.5366 10.6931 13.5366 10.7497V23.3279C13.5366 23.4329 13.6802 23.5244 13.8516 23.5244Z",
    fill: "#D1B3AA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2498 18.6196H17.5846C17.6288 18.6196 17.6656 18.6005 17.6656 18.5784V15.9335C17.6656 15.911 17.6288 15.8922 17.5846 15.8922H12.2498C12.2307 15.8917 12.2117 15.8955 12.1943 15.9035L12.1936 15.9054C12.1936 15.9054 12.1921 15.9054 12.1909 15.9061C12.1778 15.9125 12.1692 15.9211 12.1692 15.9335V18.5784C12.1692 18.6016 12.2056 18.6196 12.2498 18.6196ZM27.1437 19.6104H33.1107C33.1594 19.6104 33.2011 19.5837 33.2011 19.5522V15.8551C33.2011 15.8236 33.1594 15.797 33.1107 15.797H27.1437C27.1217 15.796 27.1 15.8015 27.0811 15.8127V15.8154L27.0807 15.8161C27.0733 15.8196 27.0671 15.8251 27.0628 15.832C27.0586 15.8389 27.0564 15.847 27.0567 15.8551V19.5522C27.0567 19.5837 27.0964 19.6104 27.1471 19.6104",
    fill: "#F2DDD5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3514 14.8975H34.5182C34.712 14.8975 34.868 14.8844 34.868 14.8698V13.0709C34.868 13.0559 34.712 13.0431 34.5182 13.0431H11.3552C11.2745 13.0423 11.1938 13.0449 11.1133 13.051C11.1133 13.051 11.1107 13.051 11.1088 13.0518C11.1088 13.0518 11.1017 13.0518 11.0975 13.0525C11.0405 13.0555 11.0034 13.0626 11.0034 13.0705V14.8698C11.0034 14.884 11.1632 14.8975 11.3548 14.8975",
    fill: "#34484C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/card-icon.69bcc50204fa56929cad71c9ed1b7730.svg";
export { ForwardRef as ReactComponent };